import { Component, Input, OnInit } from '@angular/core';
import { NavmenuService, Menu } from '../../../services/navmenu.service';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { SvgIconComponent } from '../../svg-icon/svg-icon.component';
import { ClickOutsideDirective } from '../../../directives/outside.directive';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { SiteSearchService } from '../../../services/site-search.service';
import { ToastService } from '../../../services/toast.service';
import { NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ApiCallsService } from '../../../services/api-calls.service';

interface LocationItem {
  id: string;
  location_no?: string;
  shortCode?: string;
  [key: string]: any;
}

@Component({
  selector: 'app-search',
  imports: [SvgIconComponent, FormsModule, ReactiveFormsModule, CommonModule, RouterModule, ClickOutsideDirective, NgbModule],
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit {
  public isopen: boolean = false;
  public loginType: string | null = localStorage.getItem('login_Type');
  public menuItems: Menu[] = [];
  public searchResult: boolean = false;
  public searchResultEmpty: boolean = false;
  public text: string = '';
  public open = false;
  public gridApi: any;
  @Input() scrollOpen: boolean = false;

  public basicDropdownData: any[] = [];
  siteid: string;

  // Location dropdown properties
  Locations: LocationItem[] = [];
  filteredLocations: LocationItem[] = [];
  selectedLocation: LocationItem | null = null;
  showLocationDropdown: boolean = false;
  selectedLocationIndex: number = -1;

  constructor(
    public navServices: NavmenuService,
    private toast: ToastService,
    private router: Router,
    private siteSearch: SiteSearchService,
    private route: ActivatedRoute,
    private apiservice: ApiCallsService
  ) {
    // ✅ Clear shortcode on normal navigation
    this.router.events
      .pipe(filter(event => event instanceof NavigationStart))
      .subscribe(() => {
        this.siteSearch.clearShortCode();
      });
  }

  showsearch: boolean = true;
  routeurl: string = '';
  setquery: boolean = false;

  getLocationList(siteid: string | null = ''): void {
    const site_id = siteid ?? '';

    if (!site_id) {
      this.Locations = [];
      this.filteredLocations = [];
      this.selectedLocation = null;
      return;
    }

    this.apiservice.getLocationList(site_id).subscribe(res => {
      let data: any[] = [];
      data = res?.Data || [];
      this.Locations = data;
      this.filteredLocations = data;
    });
  }

  ngOnInit(): void {
    this.route.queryParamMap.subscribe(params => {
      const querySiteId = params.get('siteid') || '';
      const localSiteId = localStorage.getItem('site_idLogin');
      const encodedId = querySiteId || localSiteId;

      this.siteid = encodedId ? atob(encodedId) : '';

      if (this.siteid !== 'ALL') {
        this.showsearch = false;
        this.setquery = !!querySiteId;
        this.routeurl = 'consumer_search';
        this.getLocationList(this.siteid);
        this.basicDropdownData = [
          {
            class: 'btn-primary text-white',
            title: 'Select',
            item: [
              { list: 'Unit No' }
            ]
          }
        ];
        this.basicDropdownData[0].title = 'Unit No'
      } else {
        this.routeurl = '/site_summary/site';
        this.setquery = false;
        this.basicDropdownData = [
          {
            class: 'btn-primary text-white',
            title: 'Select',
            item: [
              { list: 'Short Code' }
            ]
          }
        ];
      }
    });
  }

  openDrpdwn() {
    this.isopen = !this.isopen;
  }

  openSearch() {
    this.open = !this.open;
  }

  openMenu() {
    this.open = !this.open;
  }

  // ✅ NEW: Handle focus on search input - show all locations
  onSearchFocus(event?: any): void {
    if (this.siteid !== 'ALL') {
      // ✅ Check if 'Unit No' is selected
      if (this.basicDropdownData[0].title !== 'Unit No') {
        this.toast.showToast('Please select "Unit No" option', 'colored', 4000, 'warning');
        return;
      }

      this.showLocationDropdown = true;
      this.filteredLocations = this.Locations;
      this.selectedLocationIndex = -1;
    }
  }

  // ✅ NEW: Filter locations based on input text
  onSearchInput(value: string): void {
    this.text = value;
    if (this.siteid !== 'ALL') {
      // ✅ Check if 'Unit No' is selected
      if (this.basicDropdownData[0].title !== 'Unit No') {
        return;
      }

      if (!value.trim()) {
        this.filteredLocations = this.Locations;
      } else {
        const searchTerm = value.toLowerCase();
        this.filteredLocations = this.Locations.filter(location => {
          const unitNo = location.location_no?.toLowerCase() || '';
          const id = location.id?.toLowerCase() || '';
          return unitNo.includes(searchTerm) || id.includes(searchTerm);
        });
      }
      this.selectedLocationIndex = -1;
    }
  }
  // ✅ NEW: Select location from dropdown
  selectLocation(location: LocationItem): void {
    this.selectedLocation = location;
    this.text = location.location_no || '';
    this.showLocationDropdown = false;
    this.executeSearch();
  }

  // ✅ NEW: Handle keyboard navigation
  onSearchKeydown(event: KeyboardEvent): void {
    if (!this.showLocationDropdown || this.filteredLocations.length === 0) {
      if (event.key === 'Enter') {
        this.searchbyshort(this.text);
      }
      return;
    }

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        this.selectedLocationIndex = Math.min(
          this.selectedLocationIndex + 1,
          this.filteredLocations.length - 1
        );
        break;
      case 'ArrowUp':
        event.preventDefault();
        this.selectedLocationIndex = Math.max(this.selectedLocationIndex - 1, -1);
        break;
      case 'Enter':
        event.preventDefault();
        if (this.selectedLocationIndex >= 0) {
          this.selectLocation(this.filteredLocations[this.selectedLocationIndex]);
        } else {
          this.searchbyshort(this.text);
        }
        break;
      case 'Escape':
        event.preventDefault();
        this.showLocationDropdown = false;
        break;
    }
  }

  // ✅ NEW: Execute search with selected location
  executeSearch(): void {
    if (!this.selectedLocation) {
      this.toast.showToast('Please select a location', 'colored', 4000, 'warning');
      return;
    }

    const locationId = this.selectedLocation.location_no || '';

    const navigationExtras = this.setquery
      ? { queryParams: { siteid: btoa(this.siteid) } }
      : {};

    this.router.navigate([this.routeurl], navigationExtras).then(() => {
      this.siteSearch.setShortCode(locationId);

      setTimeout(() => {
        const siteTabular = document.getElementById('site_tabular');
        if (siteTabular) {
          siteTabular.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    this.text = '';
    this.selectedLocation = null;
  }

  // ✅ Original search method (for backward compatibility)
  searchbyshort(term: any) {
    if (this.basicDropdownData[0].title === 'Select') {
      this.toast.showToast('Please select an option', 'colored', 4000, 'warning');
      return;
    }

    if (!term) {
      this.siteSearch.clearShortCode();
      return;
    }

    const navigationExtras = this.setquery
      ? { queryParams: { siteid: btoa(this.siteid) } }
      : {};

    this.router.navigate([this.routeurl], navigationExtras).then(() => {
      this.siteSearch.setShortCode(term);

      setTimeout(() => {
        const siteTabular = document.getElementById('site_tabular');
        if (siteTabular) {
          siteTabular.scrollIntoView({ behavior: 'smooth' });
        }
      });
    });

    this.text = '';
  }
  selectedType: string = ''
  getData(dt: any) {
    this.basicDropdownData[0].title = dt;
  }

  checkSearchResultEmpty(items: Menu[]) {
    if (!items.length)
      this.searchResultEmpty = true;
    else
      this.searchResultEmpty = false;
  }

  addFix() {
    this.searchResult = true;
    document.body.classList.add('offcanvas');
  }

  removeFix() {
    this.searchResult = false;
    this.text = '';
    this.showLocationDropdown = false;
    document.body.classList.remove('offcanvas');
  }

  clickOutside(): void {
    this.searchResult = false;
    this.searchResultEmpty = false;
    this.showLocationDropdown = false;
    document.body.classList.remove('offcanvas');
  }
}